import React from "react";
import { Table, TableBody, TableRow, TableCell, Chip } from "@mui/material";
import { isEmpty } from "src/general_components/functionEsArray";

/**
 * @param {Array} props.metadatos - Array de metadatos con propiedades label_form y valor
 * @param {number} props.groupSize - Cantidad de pares label/valor por fila (por ejemplo 2 para 4 columnas)
 */
export const GroupedMetadataTable = ({ metadatos = [], groupSize = 2 }) => {
  // Agrupar de a 'groupSize' pares (label + valor)
  const getGroupedRows = (data, size) => {
    const grouped = [];
    for (let i = 0; i < data.length; i += size) {
      grouped.push(data.slice(i, i + size));
    }
    return grouped;
  };

  const groupedMetadatos = getGroupedRows(metadatos, groupSize);

  return (
    <Table size="small">
      <TableBody>
        {groupedMetadatos.map((group, index) => (
          <TableRow key={index}>
            {group.map((item, idx) => (
              <React.Fragment key={idx}>
                <TableCell sx={{ fontWeight: "bold" }}>{item.label_form}</TableCell>
                <TableCell>
                  {isEmpty(item.valor) ? "-" : item.valor}
                  {item.fuente === 'ocr' && (
                    <Chip label="OCR" size="small" color="info" variant="outlined" sx={{ ml: 0.5, height: 16, fontSize: '0.65rem' }} />
                  )}
                </TableCell>
              </React.Fragment>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};


